export enum LoginChallengeResultType{
    Success,
    Unsuccessfully,
    Locked,
    ForgotPassword,
    Aborted
}